import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Role} from '../../graphql/auth';

interface RolesData {
    roles: Role[],
}

export const GET_ROLES_QUERY = gql`
    query getRoles{
        roles{
            id
            name
            ident
            description
            active
            level
            users {
                id
            }
        }
    }
`;

export const getRoles = () => useQuery<RolesData>(
    GET_ROLES_QUERY,
    {
        variables: {},
    }
);

export default getRoles;
